import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, CircularProgress, ClickAwayListener, Divider, Grid, Grow, ListItemIcon, ListItemText, MenuItem, MenuList, Paper, Popper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FiMinusCircle, FiPlusCircle } from 'react-icons/fi';
import { useStyles } from './styles';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axiosInstance from '../../../environment/axiosInstance';
import { useHistory, useParams } from "react-router-dom";
import { decode } from 'html-entities';
import { toast } from 'react-toastify';
import Switch from "react-switch";
import 'react-toastify/dist/ReactToastify.css';
toast.configure();

function EditProduct(props: any) {
    const classes = useStyles();
    const history = useHistory();
    const [openExpand, setOpenExpand] = React.useState(true);
    const [title, setTitle] = useState("");
    const [title_error, setTitleError] = useState("");
    const [status, setStatus] = useState(true);

    useEffect(() => {
        axiosInstance.get('/support/business_owner/product/' + props.match.params.id).then((res: any) => {
            // console.log('desk', res)
            if (res.status === 200) {
                setTitle(res.data.Data?.name);
                setStatus(res.data.Data?.status);
            }
        }).catch((err: any) => {

        });
    }, []);

    const expandOpen = () => {
        setOpenExpand(!openExpand)
    }

    const handleStatusChange = (checked: any) => {
        setStatus(checked);
    }

    const handleValidation = () => {
        var isValid = true;

        if (!title) {
            setTitleError("*Title is required.");
            isValid = false;
        }
        else {
            setTitleError("");
        }

        return isValid;
    }

    const onFormSubmit = (e: any) => {
        e.preventDefault();

        if (handleValidation()) {
            axiosInstance
                .patch("support/business_owner/product/edit/" + props.match.params.id, {
                    name: title,
                    status: status
                })
                .then((res: any) => {
                    if (res.data.statusCode == 200) {
                        history.push("/dashboard/settings/products");
                        toast.success(res.data.message, {
                            position: toast.POSITION.TOP_RIGHT, autoClose: 1000
                        });
                    }
                    else {
                        console.log(res);
                    }
                });
        }
    }


    return (
        <div>
            <Card className={classes.card}>
                <Accordion expanded={openExpand}
                    onChange={expandOpen}>
                    <AccordionSummary
                        expandIcon={openExpand ? <FiMinusCircle color="#2645ad" onClick={expandOpen} /> : <FiPlusCircle color="#2645ad" onClick={expandOpen} />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography className={classes.heading}>Edit Product</Typography>
                    </AccordionSummary>
                    <Divider className={classes.divider} />
                    <div className={classes.cardBody}>
                        <form onSubmit={(e) => onFormSubmit(e)}>
                            <div className='row m-0'>
                                <div className={classes.titleRow}>
                                    <label><b>Title:</b></label>
                                    <input
                                        type="text"
                                        className={classes.inputField}
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                    />
                                </div>
                                <p className='m-0 text-danger'>{title_error}</p>
                                <br />
                                <div>
                                    <label className={classes.statusRow}>
                                        <span><b>Status:</b>&nbsp;</span>
                                        <Switch
                                            onChange={handleStatusChange}
                                            checked={status}
                                            height={18}
                                            width={40}
                                            className={classes.statusSwitch}
                                        />
                                    </label>
                                </div>

                                <div className='col-12 text-center'>
                                    <input type='submit' className={'btn ' + classes.submitBtn} />
                                </div>
                            </div>
                        </form>
                    </div>
                </Accordion>
            </Card>
        </div>
    )
}

export default EditProduct